var jQuery = $;
import slick from '../../node_modules/slick-carousel/slick/slick.min.js';
import fancy from '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';

const app = {
    /**
     * Initialize.
     */
    init() {
        // Smooth scroll to anchor
        this.smoothAnchor();

        // Fade sections in on scroll
        this.fadeInOnScroll();

        // Initialize sliders
        this.initSliders();

        // Toggle category items
        this.toggleCategoryItems();

        // Toggle category items element on mobile
        this.toggleCategoriesMobile();

        // Toogle Footer items
        this.toggleFooterItems();

        this.paginationItems();
        this.paginationItemsBottom();

        this.paginationStep();

        this.openPopup();

        // Register our event listeners
        $(window).on('scroll', $.proxy(this.windowScrollHandler, this));
        $('.hamburger').on('click', $.proxy(this.toggleHamburgerMenu, this));
    },

    /** Handles the scroll event. */
    windowScrollHandler() {
        $('header').toggleClass('is-scrolled', $(window).scrollTop() > 0);
    },

    /** Open hamburger menu. */
    toggleHamburgerMenu() {
        $(".hamburger").toggleClass('is-active');
        $("nav.navigation").toggleClass('visible');
        $("header").toggleClass('is-active');
        $("body").toggleClass('is-locked');
    },

    /** Smooth scroll to Anchor */
    smoothAnchor() {
        var $root = $('html, body');

        $('a:not(.toggle-categories)[href^="#"]').click(function () {
            $root.animate({
                scrollTop: $($.attr(this, 'href')).offset().top - 80
            }, 500);

            return false;
        });
    },

    /** Fade sections in on scroll */
    fadeInOnScroll() {
        $.fn.initFadeIn = function () {
            $('.section:not(.section-pageheader)').each(function () {
                let top_of_element = $(this).offset().top + 150;
                let bottom_of_element = $(this).offset().top + $(this).outerHeight();
                let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
                let top_of_screen = $(window).scrollTop();
                if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element) && !$(this).hasClass('is-visible')) {
                    $(this).addClass('is-visible');
                }
            });
        };
        $.fn.initFadeIn();
        $(window).scroll(function () {
            $.fn.initFadeIn();
        });
    },

    /** Initialize Sliders */
    initSliders() {

        // Topbar USP items
        if ($(window).width() < 1025) {
            if ($('.topbar .container .topbar-usp-items').length) {
                $('.topbar .container .topbar-usp-items').slick({
                    autoplay: true,
                    autoplaySpeed: 0,
                    speed: 8000,
                    cssEase: 'linear',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                    swipe: false,
                    pauseOnFocus: false,
                    pauseOnHover: false,
                    swipeToSlide: false,
                    variableWidth: true
                });
            }
        }
    },

    /** Toggle category items */
    toggleCategoryItems() {

        $('.category .category-title').click(function (e) {
            // e.preventDefault();
            let $this = $(this);
            if ($this.parent().hasClass('is-opened')) {
                $this.parent().removeClass('is-opened').find('.category-content').slideUp();
            } else {
                $this.parent().addClass('is-opened').find('.category-content').slideDown();
            }
        });

        $('.sidebar-block .category').each(function () {
            if ($(this).hasClass('is-opened')) {
                if ($(this).find('.category-content').is(':hidden')) {
                    $(this).find('.category-content').slideDown();
                }
            }
        });
    },

    /** Toggle category items element on mobile */
    toggleCategoriesMobile() {

        $('.toggle-categories').click(function (e) {
            e.preventDefault();
            $('.mobile-categories').toggleClass('is-opened');
        });

        // Check for active category
        if ($('.mobile-categories').length) {
            let urlParts = window.location.pathname.split('/');
            let lastUrlPart = urlParts.pop() || urlParts.pop();

            if (lastUrlPart) {
                $('.mobile-categories .category').each(function () {
                    if ($(this).data('category') == lastUrlPart) {
                        $(this).addClass('is-opened').find('.category-content').show();
                    }
                });
            }
        }

        // If no category is opened, open the first one
        if (!$('.mobile-categories .category.is-opened').length) {
            $('.mobile-categories .category').first().addClass('is-opened').find('.category-content').show();
        }

        $('.mobile-categories .close-popup').on('click', function () {
            $('.mobile-categories').removeClass('is-opened');
        });
    },

    toggleFooterItems() {

        if ($(window).width() < 769) {

            let allFooterItems = $('footer .footer-items > .footer-item > .inner > .footer-item-content').hide();

            $('footer .footer-items > .footer-item > .inner > .footer-item-title').click(function () {
                let target = $(this).next();

                if (!target.hasClass('active')) {
                    allFooterItems.removeClass('active').slideUp();
                    $('footer .footer-items > .footer-item').removeClass('is-opened');
                    $(this).parent().closest('.footer-item').addClass('is-opened');
                    target.addClass('active').slideDown();
                }
                return false;
            });
        }
    },

    paginationItems() {
        // How many pages can be around the current page
        let maxAround = 1;
        // How many pages are displayed if in beginning or end range
        let maxRange = 3;
        // The current page (pass this however you like)
        let currentPage = parseInt($('#pagination-numbers').attr('data-paged'));

        // The paginator (would suggest using an ID instead)
        let $paginator = $('#pagination-numbers');

        $(document).ready(function () {
            // Upon page load, we want to set the visible pages
            updateVisiblePages();
        });

        function updateVisiblePages() {
            // Count amount of pages
            let totalPages = $paginator.children('li').length;

            let endRange = totalPages - maxRange;
            // Check if we're in the starting section
            let inStartRange = currentPage <= maxRange;
            // Check if we're in the ending section
            let inEndRange = currentPage >= endRange;

            // We need this for the span(s)
            let lastDotIndex = -1;

            // Remove all dots
            $('span.dots').remove();
            // Loop the pages
            $paginator.children('li').each(function (page, element) {
                // Index starts at 0, pages at 1
                ++page;
                let $element = $(element);
                if (page === 1 || page === totalPages) {
                    // Always show first and last
                    $element.show();
                } else if (inStartRange && page <= maxRange) {
                    // Show element if in start range
                    $element.show();
                } else if (inEndRange && page >= endRange) {
                    // Show the element if in ending range
                    $element.show();
                } else if (page === currentPage - maxAround || page === currentPage || page === currentPage + maxAround) {
                    // Show element if in the wrap around
                    $element.show();
                } else {
                    // Doesn't validate, hide it.
                    // Append dot if needed
                    $element.hide();

                    if (lastDotIndex === -1 || (!inStartRange && !inEndRange && $('span.dots').length < 2 && page > currentPage)) {
                        lastDotIndex = page;
                        // Insert dots after this page, we only have one or 2, and we can only insert the second one
                        // if we're not in the start or end range, and it's past the current page
                        $element.after('<span style="color: #AE9250" class="dots">...</span>');
                    }
                }
            });
        }
    },

    paginationItemsBottom() {
        // How many pages can be around the current page
        let maxAround = 1;
        // How many pages are displayed if in beginning or end range
        let maxRange = 3;
        // The current page (pass this however you like)
        let currentPage = parseInt($('#pagination-numbers-bottom').attr('data-paged'));

        // The paginator (would suggest using an ID instead)
        let $paginator = $('#pagination-numbers-bottom');

        $(document).ready(function () {
            // Upon page load, we want to set the visible pages
            updateVisiblePages();
        });

        function updateVisiblePages() {
            // Count amount of pages
            let totalPages = $paginator.children('li').length;

            let endRange = totalPages - maxRange;
            // Check if we're in the starting section
            let inStartRange = currentPage <= maxRange;
            // Check if we're in the ending section
            let inEndRange = currentPage >= endRange;

            // We need this for the span(s)
            let lastDotIndex = -1;

            // Remove all dots
            $('span.dots').remove();
            // Loop the pages
            $paginator.children('li').each(function (page, element) {
                // Index starts at 0, pages at 1
                ++page;
                let $element = $(element);
                if (page === 1 || page === totalPages) {
                    // Always show first and last
                    $element.show();
                } else if (inStartRange && page <= maxRange) {
                    // Show element if in start range
                    $element.show();
                } else if (inEndRange && page >= endRange) {
                    // Show the element if in ending range
                    $element.show();
                } else if (page === currentPage - maxAround || page === currentPage || page === currentPage + maxAround) {
                    // Show element if in the wrap around
                    $element.show();
                } else {
                    // Doesn't validate, hide it.
                    // Append dot if needed
                    $element.hide();

                    if (lastDotIndex === -1 || (!inStartRange && !inEndRange && $('span.dots').length < 2 && page > currentPage)) {
                        lastDotIndex = page;
                        // Insert dots after this page, we only have one or 2, and we can only insert the second one
                        // if we're not in the start or end range, and it's past the current page
                        $element.after('<span style="color: #AE9250" class="dots">...</span>');
                    }
                }
            });
        }
    },

    paginationStep() {
        $(".pagination-step").click(function (e) {
            e.preventDefault();
            let currentPage = parseInt($('#pagination-numbers').attr('data-paged'));
            let url = window.location.href;
            var regEx = /([?&]page)=([^#&]*)/g;
            if ($(this).attr("id") == "previouslink") {
                let page = currentPage - 1;
                let newurl = url.replace(regEx, '$1=' + page + '');
                window.location.href = newurl;
            }
            if ($(this).attr("id") == "nextlink") {
                let page = currentPage + 1;
                let newurl = url.replace(regEx, '$1=' + page + '');
                window.location.href = newurl;
            }
        });
    },

    /** Open Pop-ups */
    openPopup() {

        if ($(".popup.blog").length) {
            $('.open-popup, a[href="#popup-blog"]').click(function (e) {
                e.preventDefault();

                $.fancybox.open({
                    buttons: [],
                    src: ".popup.for-blog",
                    type: "inline",
                    clickOutside: "close",
                    afterClose: function (e) {
                        $.fancybox.close();
                    }
                });
            });
        }
    },
};
$(document).ready($.proxy(app.init, app));
